export default "__VITE_ASSET__DCmMGmhC__"